export default "__VITE_ASSET__BEMFje7S__"